(() => {
  const mobileViewport = window.matchMedia('(max-width: 798px)');

  function disableMobileHoverHandlers() {
    if (!mobileViewport.matches || !window.jQuery) return;
    window.jQuery('#header .cart-container').off('mouseenter mouseleave');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableMobileHoverHandlers);
  } else {
    disableMobileHoverHandlers();
  }
  mobileViewport.addEventListener('change', event => {
    if (event.matches) disableMobileHoverHandlers();
  });

  function closeCart() {
    document.querySelectorAll('#header .cart_content').forEach(content => {
      content.style.transition = 'right 0.2s ease';
      content.style.right = '-100%';
    });
    document.body.classList.remove('is-active', 'blocked-scroll', 'openCart', 'mobile-drawer-open');
    document.querySelectorAll('.dropdown_link, .cart-container').forEach(element => {
      element.classList.remove('active_link');
    });
  }

  const cartStateObserver = new MutationObserver(() => {
    if (document.body.classList.contains('openCart')) return;
    document.querySelectorAll('#header .cart_content').forEach(content => {
      content.style.transition = 'right 0.2s ease';
      content.style.right = '-100%';
    });
  });
  cartStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  function getCartContent(container) {
    let content = container.querySelector('.cart_content');
    if (content) return content;

    const template = document.querySelector('.header .cart_content');
    if (!template) return null;

    content = template.cloneNode(true);
    container.append(content);
    return content;
  }

  window.addEventListener('click', event => {
    if (!mobileViewport.matches) return;

    const closeButton = event.target.closest('.cart_content .closeButton');
    const veil = event.target.closest('.mobile-drawer-veil');
    if (closeButton || veil) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (veil && document.body.classList.contains('mobile-nav-open') && window.mobileMenuDrawer) {
        window.mobileMenuDrawer.close();
      }
      closeCart();
      return;
    }

    const trigger = event.target.closest('.mini_cart');
    if (!trigger) return;

    const container = trigger.closest('.cart-container');
    const content = container ? getCartContent(container) : null;
    if (!container || !content) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (container.classList.contains('active_link') && document.body.classList.contains('openCart')) {
      closeCart();
      return;
    }

    if (window.mobileMenuDrawer) window.mobileMenuDrawer.close();
    document.querySelectorAll('.dropdown_link, .cart-container').forEach(element => {
      element.classList.remove('active_link');
    });
    container.classList.add('active_link');
    document.body.classList.add('is-active', 'openCart', 'mobile-drawer-open');
    content.style.transition = 'right 0.2s ease';
    content.style.right = '0px';
  }, true);
})();
